/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import {ActionRequestStateAfterService} from "./ActionRequestStateAfterService";

class ActionRequestStateAfterServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ActionRequestStateAfterService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { ActionRequestStateAfterServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestStateAfterServiceProvider.js